import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TokenService } from '@app/auth/token.service';

@Injectable()
export class PortalAuthInterceptor implements HttpInterceptor {
  constructor(private tokenService: TokenService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const portalBffContextPaths: string[] = [
      '/portal-bff/matricula/',
      '/portal-bff/usuario/',
      '/portal-bff/boleto/'
    ];

    const isPortalBffContext = Boolean(
      portalBffContextPaths.find((item: string) => request.url.includes(item))
    );

    if (isPortalBffContext) {
      request = this.setBearerInAuthorizationHeaderRequest(request);
    }
    return next.handle(request);
  }

  private setBearerInAuthorizationHeaderRequest(
    request: HttpRequest<any>
  ): HttpRequest<any> {
    const token = this.tokenService.getToken();
    if (token) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return request;
  }
}
